// extracted by mini-css-extract-plugin
export var modal = "_fj-0";